import React from "react";
import Grainient from "./Grainient";

function usePrefersReducedMotion() {
  const [reduce, setReduce] = React.useState(
    () =>
      typeof window !== "undefined" &&
      window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches
  );

  React.useEffect(() => {
    const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
    const onChange = () => setReduce(mq.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);

  return reduce;
}

/**
 * WebGL grain backdrop inside `.store-page` / `.store-category-page` (absolute, not fixed,
 * so it does not paint over the shared site footer). Skipped when the user prefers reduced
 * motion — CSS gradient on the store section remains.
 */
export default function StoreGrainientBackdrop() {
  const reduceMotion = usePrefersReducedMotion();
  if (reduceMotion) return null;

  return (
    <div className="store-grainient-layer" aria-hidden="true">
      <Grainient
        color1="#fbf7f0"
        color2="#e6d5c4"
        color3="#c9a882"
        timeSpeed={0.12}
        colorBalance={0.02}
        warpStrength={1}
        warpFrequency={4.5}
        warpSpeed={1.1}
        warpAmplitude={48}
        blendAngle={8}
        blendSoftness={0.08}
        rotationAmount={420}
        noiseScale={2}
        grainAmount={0.09}
        grainScale={2.2}
        grainAnimated={false}
        contrast={1.22}
        gamma={1.02}
        saturation={0.9}
        centerX={0}
        centerY={0}
        zoom={0.92}
      />
    </div>
  );
}
